import { goSolidApi } from "@/composables/useGoSolidApi";
import type { TgeLegalForm } from "@/types";

/**
 * Registry options a statement's beneficiary already answers, namespaced per registry family like the
 * statement's own options. A family the registry does not use is null.
 *
 * @property tge_options.legal_form - Read from the beneficiary name; null when the user has to choose.
 */
export interface CancelStatementDefaults {
  tge_options: { legal_form: TgeLegalForm | null } | null;
}

/**
 * `GET /api/company/:companyId/portfolio/cancel/statement-defaults`: what the backend can read off the
 * beneficiary name for the given registry, so the cancel editor prefills it instead of asking.
 */
export const cancelStatementDefaultsApi = {
  get: (
    companyId: number,
    beneficiaryName: string,
    registryCountryRegion: string
  ) =>
    goSolidApi.get<CancelStatementDefaults>(
      `/api/company/${companyId}/portfolio/cancel/statement-defaults`,
      {
        params: {
          beneficiary_name: beneficiaryName,
          registry_country_region: registryCountryRegion,
        },
      }
    ),
};
